function initCustomBundle() {
    const customBundleContainer = document.querySelector(".js-custom-bundle-container"),
        bundleBuilderModal = document.querySelector(".js-bundle-builder-modal");
    customBundleContainer && bundleBuilderModal && window.addEventListener("scroll", () => {
        window.scrollY > customBundleContainer.offsetTop + 500 ? bundleBuilderModal.classList.add("scrolled") : bundleBuilderModal.classList.remove("scrolled")
    }), document.querySelectorAll(".js-add-to-bundle").forEach(button => {
        button.addEventListener("click", () => {
            const productId = button.dataset.productId;
            addToBundle(productId)
        })
    }), updateButtonsState("not-ready"), document.querySelectorAll(".js-bundle-product-remove").forEach(button => {
        button.addEventListener("click", () => {
            removeFromBundle(button.dataset.variantId)
        })
    }), document.querySelectorAll(".js-add-bundle-to-cart").forEach(button => {
        button.addEventListener("click", () => {
            addBundleToCart()
        })
    }), document.querySelectorAll(".js-bundle-product-card-option-value").forEach(optionValue => {
        optionValue.addEventListener("click", () => {
            updateSelectedProductVariant(optionValue)
        })
    }), document.querySelectorAll(".js-custom-bundle-product-grid-item").forEach(productCard => {
        let selectedOptionValue = productCard.querySelector(".js-bundle-product-card-option-value.selected");
        selectedOptionValue && updateSelectedProductVariant(selectedOptionValue)
    })
}

function addToBundle(productId) {
    let productCardVariant = document.querySelector(`.js-custom-bundle-product-grid-item[data-product-id="${productId}"]`).querySelector(".js-bundle-product-variant.selected"),
        productVariantId = productCardVariant.value,
        productImage = productCardVariant.dataset.image,
        productTitle = productCardVariant.dataset.title,
        productPrice = productCardVariant.dataset.price,
        productAvailable = productCardVariant.dataset.available,
        productImageAltText = productCardVariant.dataset.imageAltText,
        bundleBuilder = document.querySelector(".js-bundle-builder"),
        bundleBuilderModal = document.querySelector(".js-bundle-builder-modal"),
        bundleBuilderProducts = bundleBuilder.querySelectorAll(".js-bundle-product"),
        bundleBuilderModalProducts = bundleBuilderModal.querySelectorAll(".js-bundle-product"),
        bundleBuilderProductIndex = 0,
        emptySlotFound = !1;
    bundleBuilderProducts.forEach((product, index) => {
        product.classList.contains("empty") && !emptySlotFound && (product.dataset.productId = productId, bundleBuilderProductIndex = index, product.querySelector(".js-bundle-product-image").src = productImage, product.querySelector(".js-bundle-product-image").srcset = productImage, product.querySelector(".js-bundle-product-image").alt = productImageAltText, product.querySelector(".js-bundle-product-title").innerHTML = productTitle, product.querySelector(".js-bundle-product-remove").dataset.variantId = productVariantId, product.dataset.price = productPrice, product.dataset.variantId = productVariantId, product.classList.remove("empty"), emptySlotFound = !0)
    }), bundleBuilderModalProducts[bundleBuilderProductIndex].dataset.productId = productId, bundleBuilderModalProducts[bundleBuilderProductIndex].querySelector(".js-bundle-product-image").src = productImage, bundleBuilderModalProducts[bundleBuilderProductIndex].querySelector(".js-bundle-product-image").srcset = productImage, bundleBuilderModalProducts[bundleBuilderProductIndex].querySelector(".js-bundle-product-remove").dataset.variantId = productVariantId, bundleBuilderModalProducts[bundleBuilderProductIndex].dataset.price = productPrice, bundleBuilderModalProducts[bundleBuilderProductIndex].dataset.variantId = productVariantId, bundleBuilderModalProducts[bundleBuilderProductIndex].classList.remove("empty"), updateBundlePrice(bundleBuilderProducts);
let productCount = 0;

bundleBuilderProducts.forEach(product => {
    if (!product.classList.contains("empty")) {
        productCount++;
    }
});

updateButtonsState(productCount);
}

function updateBundlePrice(products) {
    let totalPriceEls = document.querySelectorAll(".js-bundle-price"),
        totalSavingsEls = document.querySelectorAll(".js-bundle-saved"),
        totalPrice = 0,
        productCount = 0;

    products.forEach(product => {
        let price = parseFloat(product.dataset.price || 0);
        if (!product.classList.contains("empty") && price > 0) {
            totalPrice += price;
            productCount++;
        }
    });

    // 根据产品数量决定折扣比例
    let discountRate = 0;

    if (productCount === 1) {
    } else if (productCount === 2) {
        discountRate = 0.05;
        
    } else if (productCount >= 3) {
       discountRate = 0.10;
    }

    let totalSavings = (totalPrice * discountRate).toFixed(2);
    let finalPrice = (totalPrice - totalSavings).toFixed(2);

    totalPriceEls.forEach(el => {
        el.innerHTML = finalPrice;
    });

    totalSavingsEls.forEach(el => {
        el.innerHTML = totalSavings;
    });
}

function updateButtonsState(productCount, maxSlots = 3) {
    let addToBundleButtons = document.querySelectorAll(".js-add-to-bundle"),
        addToCartButtons = document.querySelectorAll(".js-add-bundle-to-cart");

    // ① 控制 Add to Cart（只要 ≥1）
    addToCartButtons.forEach(btn => {
        btn.disabled = productCount === 0;
    });

    // ② 控制 Add to Bundle（只有满了才禁用）
    if (productCount >= maxSlots) {
        addToBundleButtons.forEach(btn => {
            btn.disabled = true;
            btn.textContent = "Bundle Full";
        });
    } else {
        addToBundleButtons.forEach(btn => {
            btn.disabled = false;
            btn.textContent = "Add to Bundle";
        });
    }
}

function removeFromBundle(variantId) {
    let bundleProducts = document.querySelectorAll(".js-bundle-product"),
        bundleBuilderProducts = document.querySelector(".js-bundle-builder").querySelectorAll(".js-bundle-product");
    bundleProducts.forEach((product, index) => {
        product.dataset.variantId === variantId && (product.classList.add("empty"), product.dataset.productId = "", product.dataset.price = "0", product.dataset.variantId = "", product.querySelector(".js-bundle-product-image").src = productImageDefault, product.querySelector(".js-bundle-product-image").srcset = productImageDefault, product.querySelector(".js-bundle-product-title").innerHTML = "", product.querySelector(".js-bundle-product-remove").dataset.variantId = "")
    }), 
    updateBundlePrice(bundleBuilderProducts);


let productCount = 0;
bundleBuilderProducts.forEach(product => {
    if (!product.classList.contains("empty")) {
        productCount++;
    }
});

updateButtonsState(productCount);
}

function addBundleToCart() {
    let bundleBuilderProducts = document
        .querySelector(".js-bundle-builder")
        .querySelectorAll(".js-bundle-product");

    let formData = { items: [] };

    bundleBuilderProducts.forEach(product => {
        let variantId = product.dataset.variantId;

        if (variantId && variantId !== "") {
            formData.items.push({
                id: variantId,
                quantity: 1,
                properties: {
                    _custom_bundle: "true"
                }
            });
        }
    });

    if (formData.items.length === 0) return;

    fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(responseJson => {

        // ✅ 加购成功后刷新 cart
        return fetch(`${window.themeVariables.routes.cartUrl}.js`)
            .then(async (response2) => {
                const cartContent = await response2.json();

                document.documentElement.dispatchEvent(
                    new CustomEvent("cart:updated", {
                        bubbles: true,
                        detail: { cart: cartContent }
                    })
                );

                cartContent["sections"] = responseJson["sections"];

                document.documentElement.dispatchEvent(
                    new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {
                            cart: cartContent,
                            openMiniCart:
                                window.themeVariables.settings.cartType === "drawer"
                        }
                    })
                );
            });

    })
    .catch(error => {
        console.error("Error:", error);
    });

    // 清空 bundle
    bundleBuilderProducts.forEach(product => {
        if (product.dataset.variantId) {
            removeFromBundle(product.dataset.variantId);
        }
    });
}

function updateSelectedProductVariant(optionValue, skipFiltering) {
    let optionName = optionValue.dataset.optionItem,
        productId = optionValue.dataset.productId;
    optionValue.closest(".product-block-options").querySelectorAll(".js-bundle-product-card-option-value").forEach(optionValue2 => {
        optionValue2.classList.remove("selected")
    }), optionValue.classList.add("selected");
    let productCard = document.querySelector(`.js-custom-bundle-product-grid-item[data-product-id="${productId}"]`),
        variantInputs = productCard.querySelectorAll(".js-bundle-product-variant"),
        selectedOptions = productCard.querySelectorAll(".js-bundle-product-card-option-value.selected"),
        selectedValues = [];
    selectedOptions.forEach(option => {
        selectedValues.push(option.dataset.optionItem)
    });
    let imageUrl = "",
        available = !1,
        price = 0,
        imageAltText = "",
        variantMatch = !1;
    if (variantInputs.forEach(variantInput => {
            selectedValues.every(value => variantInput.dataset.title.includes(value)) ? (variantInput.classList.add("selected"), imageUrl = variantInput.dataset.image, imageAltText = variantInput.dataset.imageAltText, available = variantInput.dataset.available, price = variantInput.dataset.price, variantMatch = !0) : variantInput.classList.remove("selected")
        }), !variantMatch) filterAvailableOptions(productCard, variantInputs, selectedValues);
    else {
        let productImageEl = productCard.querySelector(".js-bundle-product-card-image");
        productImageEl.src = imageUrl, productImageEl.srcset = imageUrl, productImageEl.alt = imageAltText, productCard.querySelector(".js-bundle-product-card-price").innerHTML = "$" + price;
        let optionNameEL = optionValue.closest(".custom-bundle-product-grid-item-variant-picker-option").querySelector(".js-option-value");
        optionNameEL.innerHTML = optionName;
        let addToBundleButton = productCard.querySelector(".js-add-to-bundle");
        available === "true" ? (addToBundleButton.disabled = !1, addToBundleButton.textContent = "Add to Bundle") : (addToBundleButton.disabled = !0, addToBundleButton.textContent = "Sold Out")
    }
    skipFiltering || filterAvailableOptions(productCard, variantInputs, selectedValues)
}

function filterAvailableOptions(productCard, variantInputs, selectedValues) {
    productCard.querySelectorAll(".js-bundle-product-card-option").forEach((optionGroup, groupIndex) => {
        if (groupIndex === 0) return;
        let optionValues = optionGroup.querySelectorAll(".js-bundle-product-card-option-value"),
            availableOptions = [],
            currentlySelected = optionGroup.querySelector(".js-bundle-product-card-option-value.selected");
        optionValues.forEach(optionValue => {
            let testSelectedValues = [...selectedValues];
            for (; testSelectedValues.length <= groupIndex;) testSelectedValues.push(optionValue.dataset.optionItem);
            testSelectedValues[groupIndex] = optionValue.dataset.optionItem;
            let isAvailable = !1;
            variantInputs.forEach(variantInput => {
                testSelectedValues.every(value => variantInput.dataset.title.includes(value)) && (isAvailable = !0)
            }), isAvailable ? (optionValue.style.display = "", optionValue.classList.remove("unavailable"), availableOptions.push(optionValue)) : (optionValue.style.display = "none", optionValue.classList.add("unavailable"))
        });
        let currentSelectionStillValid = !1;
        if (currentlySelected && availableOptions.includes(currentlySelected) && (currentSelectionStillValid = !0), !currentSelectionStillValid && availableOptions.length > 0) {
            optionValues.forEach(option => option.classList.remove("selected"));
            let firstAvailable = availableOptions[0];
            firstAvailable.classList.add("selected");
            let optionNameEL = optionGroup.querySelector(".js-option-value");
            optionNameEL && (optionNameEL.innerHTML = firstAvailable.dataset.optionItem), updateSelectedProductVariant(firstAvailable, !0)
        }
    })
}
window.addEventListener("load", () => {
    console.log("load"), initCustomBundle()
});
//# sourceMappingURL=/cdn/shop/t/106/assets/custom-bundle.js.map